module.exports = __webpack_public_path__ + "img/5b31e01.png";